import type { IconData } from '@stacksjs/iconify-core'

export const orientaton: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 10.941v7h12v-7zm0-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2m9.012-2h-2V2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H18v-2h.012V2h-7z\"/>",
  "width": 21,
  "height": 20,
  "viewBox": "0 0 21 20"
}

export default orientaton
